import { clientRect } from 'chirashi';
import { css } from 'emotion'
import { Abs, Subtitle, Colors, Link } from './'
import { ButtonLoadMoreStyle } from './components';
import { Easings } from './core';

// LOADER
export const appLoader = (transition) => css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: '#FFFFFF',
  textAlign: 'center',
  zIndex: 2,
  opacity: transition ? 0 : 1,
  transition: 'opacity 400ms ease',
  '.shape': {
    display: 'bloSubtitleck',
    margin: '2rem auto',
    'stop': {
      stopColor: '#000000',
    }
  },
  '.loader--inner': {
    ...Abs,
  },
  'p': {
    ...Subtitle,
    lineHeight: 1,
    margin: 0,
  }
})


//HEADER
export const appHeader = css({
  position: 'fixed',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '60px',
  lineHeight: '60px',
  zIndex: 4,
  background: 'white',
  '@media (min-width: 1024px)': {
    height: '80px',
    lineHeight: '80px',
  },
  '.header': {
    position: 'relative',
    zIndex: 3,
    background: 'white',
    height: '60px',
    borderBottom: `1px solid ${Colors.extraLightGrey}`,
    '@media (min-width: 1024px)': {
      height: '80px',
    },
  }
})

//FOOTER
export const appFooter = css({
  position: 'relative',
  width: '100%',
  background: '#000000',
  zIndex: 2,
  padding: '2rem 0',
  '.counter-logo': {
    width: '91px',
    marginRight: '20px'
  },
  '.counter-wrap': {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 1023px)': {
      marginLeft: '1rem',
      marginBottom: '1rem'
    },
    '@media (min-width: 1024px)': {
      position: 'absolute',
      left: '30px',
      top: 0
    }
  },
  '.counter': {
    display: 'block',
    color: `${Colors.white}`,
    fontWeight:'bold',
    fontSize: '1.25rem',
    fontFamily: 'Interstate-Bold-Condensed',
    'span': {
      marginRight: '4px',
      width: '1.25rem',
      height: '25px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#353535',
      lineHeight: 1.3,
      borderRadius: '4px'
    }
  },
  '&:after': {
    content: "''", 
    position: 'absolute',
    top: 0,
    left: 1,
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 2px)',
    zIndex: 1,
    border: `1px solid ${Colors.darkGrey}`
  },
  '@media (min-width: 1024px)': {
    height: '80px',
    lineHeight: '80px',
    padding: '0',
  },
  '& > ul ': {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    zIndex: 2,
    position: 'relative',
    'li': {
      margin: '0px 1rem',
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'auto',
        flexBasis: 'auto',
      }
    },
    'a': {
      ...Link,
      transition: 'all 200ms ease',
      fontSize: '0.75rem',
      color: Colors.mediumGrey,
      padding: '1rem 0',
      display: 'block',
      position: 'relative',
      '@media (min-width: 1024px)': {
        // display: 'inline',
        padding: 0,
        height: 80,
        lineHeight: '80px',
        padding: '0px 1rem',
        '&:after': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: 0,
          height: 4,
          width: '100%',
          background: 'white',
          transform: 'scaleX(0)',
          transformOrigin: 'center left',
          transition: `all 400ms ${Easings.customEase}`,
        },
      },
      '&:hover, &.active': {
        color: 'white',
      },
      '&.active': {
        '&:after': {
          transform: 'scaleX(1)',
        }
      }
    }
  },
  'body.nofooter &': {
    display: 'none',
  } 
})

//BODY

export const appBody = css({
  width: '100%',
  minHeight: 'calc(100vh - 60px)',
  zIndex: 1,
  padding: '60px 0px 0px',
  '@media (min-width: 1024px)': {
    minHeight: 'calc(100vh - 80px)',
    padding: '80px 0px 0px',
  },
})


// WEBPACK FOOTER //
// ./src/styles/app.js